<style lang="less" scoped>
  @import "../../vars.less";

  .btn-container {
    padding: @space-normal;
  }
</style>

<template>
  <page-container
    :title="$t('个人信息')">
    <van-cell :title="$t('用户名')" :value="userinfo.account" />
    <van-cell :title="$t('邮箱')" :value="userinfo.email" />
    <van-cell :title="$t('手机号')" :value="userinfo.phone" />
    <van-cell :title="$t('公司')" :value="userinfo.orgs ? userinfo.orgs.name : ''" />
    <div class="btn-container">
      <van-button block round type="info" plain size="small" @click="go2changePassword">{{ $t('修改密码') }}</van-button>
    </div>
  </page-container>
</template>

<script>
import { Cell, Button } from 'vant'
import PageContainer from '../../components/PageContainer'
import { LS_KEYS } from '../../constants'
import ls from '../../utils/local-storage'

export default {
  name: 'userinfo',
  components: {
    PageContainer,
    'van-cell': Cell,
    'van-button': Button
  },
  data () {
    return {
      userinfo: {}
    }
  },
  methods: {
    go2changePassword () {
      this.$router.push({
        name: 'change-password',
        params: {
          stackType: 'push'
        }
      })
    }
  },
  mounted () {
    const userinfo = ls.get(LS_KEYS.USERINFO)
    if (!userinfo) {
      this.$router.push({ name: 'login' })
    } else {
      this.userinfo = userinfo
    }
  }
}
</script>
